import { UIElement } from '../ui-element';

export class VolumeIndicatorValueElement extends UIElement {
  static readonly tagName = 'media-volume-indicator-value';
}
